export default "__VITE_ASSET__4405710f__"